import { Chip } from '@dataroom/shared';
import type { DocumentStatus, UnreadableFlag } from '@dataroom/shared';

/**
 * A submitted document's status as the SELLER sees it. The intermediary's
 * working states (Processing, Needs review / Check AI) are theirs to act on, not
 * the seller's, so the seller sees only that the file arrived ("Received") or,
 * once it is placed in the data room, "Filed" — each with a plain tooltip. A
 * file we could not read says so first ("Needs a new copy"), with the server's
 * plain request as its tooltip — that is the seller's to act on.
 */
export function SellerDocStatus({
  status,
  unreadable,
}: {
  status: DocumentStatus;
  unreadable?: UnreadableFlag | null;
}) {
  if (unreadable) {
    return (
      <Chip tone="check" icon="alert" className="cursor-default">
        <span title={unreadable.message}>Needs a new copy</span>
      </Chip>
    );
  }
  return status === 'categorized' ? (
    <Chip tone="filed" icon="folder" className="cursor-default">
      <span title="Filed in the data room">Filed</span>
    </Chip>
  ) : (
    <Chip tone="neutral" icon="check" className="cursor-default">
      <span title="We have your file. Your intermediary’s team files it in the data room.">
        Received
      </span>
    </Chip>
  );
}
